/**
 * alertRuleExceptionResource模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const alertRuleExceptionResource = {
    //批量新增例外资源
    batchCreate(params) {
        return $http.post(`${global.API_URL}/sme/alertRuleExceptionResource/batchCreate`,params);
    },
    //根据客户自定义指标id查询例外资源列表
    listAlertRuleExceptionResource(params) {
        return $http.post(`${global.API_URL}/sme/alertRuleExceptionResource/listAlertRuleExceptionResource`,params);
    },
    // 软删除例外资源
    softDelete(params) {
        return $http.post(`${global.API_URL}/sme/alertRuleExceptionResource/softDelete`,params);
    },
    //查询不在例外资源列表的资源集合
    listNotExceptionResource(params) {
        return $http.post(`${global.API_URL}/sme/alertRuleExceptionResource/listNotExceptionResource`,params);
    }
}

export default alertRuleExceptionResource;



// WEBPACK FOOTER //
// ./src/api/alertRuleExceptionResource.js